import { render, staticRenderFns } from "./TabsMain.vue?vue&type=template&id=5db66b54&"
import script from "./TabsMain.vue?vue&type=script&lang=js&"
export * from "./TabsMain.vue?vue&type=script&lang=js&"
import style0 from "./TabsMain.vue?vue&type=style&index=0&id=5db66b54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports